import { SET_MENU_MANAGEMENT_REMOTE_CONFIG } from '../types/menuManagementRemoteConfig';
import type { MenuManagementRemoteConfigPayload } from '../actions/menuManagementRemoteConfig';

export type MenuManagementRemoteConfigState = {
  paramKey: string;
  raw: string;
  data: unknown;
  error: string | null;
  loaded: boolean;
};

const initialState: MenuManagementRemoteConfigState = {
  paramKey: '',
  raw: '',
  data: null,
  error: null,
  loaded: false,
};

const menuManagementRemoteConfigReducer = (
  state = initialState,
  action: {
    type: string;
    payload?: MenuManagementRemoteConfigPayload;
  },
) => {
  switch (action.type) {
    case SET_MENU_MANAGEMENT_REMOTE_CONFIG:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default menuManagementRemoteConfigReducer;
